<p>
  You’ve declined our Terms & Conditions which means we can’t help you!<br />
  If you have a change of heart and accept our T&C’s we can pick up where we left off.
</p>
